import type { QueryClient } from "@tanstack/react-query";
import { baseDashboardQueryKey } from "../../config/request-keys";

export const invalidateCachedDashboardQueries = (queryClient: QueryClient) => {
  const dashboardQuery = queryClient.getQueryCache().find({
    queryKey: baseDashboardQueryKey,
    exact: false,
  });

  if (!dashboardQuery) {
    return undefined;
  }

  return queryClient.invalidateQueries({
    queryKey: baseDashboardQueryKey,
  });
};
